var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRccl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 48,
    viewBox: "0 0 266 48",
    fill: "none",
    id: "svg55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2692_31480)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2536 22.2414H62.6779C64.6101 22.2414 66.4839 22.2414 66.4839 19.7313C66.4839 17.548 64.3766 17.548 62.6779 17.548H61.2536V22.2414ZM57.5876 27.7928H59.5374V17.548H57.5876V16.2988H63.0106C65.6083 16.2988 68.3169 16.4564 68.3169 19.7254C68.3169 21.535 67.2661 22.7609 65.4273 22.9185V22.9594C66.3263 23.0586 66.7758 23.4497 67.0677 23.9751C67.3595 24.518 67.4996 25.2009 67.7682 25.9248L68.3169 27.7928H69.7996V29.042H66.9509L66.0928 26.2167C65.4098 23.9401 65.1938 23.4906 62.7771 23.4906H61.2536V27.7928H63.2033V29.042H57.5876V27.7928Z",
    fill: "#2755A6",
    id: "path2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.065 27.9855C77.073 27.9855 78.0129 26.4269 78.0129 24.5939C78.0129 22.761 77.073 21.2082 75.065 21.2082C73.0569 21.2082 72.0412 22.7668 72.0412 24.5939C72.0412 26.421 73.0569 27.9855 75.065 27.9855ZM75.065 19.959C77.9545 19.959 79.7291 21.6927 79.7291 24.5939C79.7291 27.4951 77.9545 29.2289 75.065 29.2289C72.1754 29.2289 70.325 27.4951 70.325 24.5939C70.325 21.6927 72.1813 19.959 75.065 19.959Z",
    fill: "#2755A6",
    id: "path4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8027 21.4006H89.8278L86.1794 29.8708C85.5373 31.3885 85.1053 32.4451 83.2899 32.4451C82.8813 32.4451 82.4726 32.3867 82.064 32.3283V31.12C82.3559 31.1375 82.6711 31.1959 82.998 31.1959C84.3465 31.1959 84.4048 30.0867 84.9477 29.036L81.4919 21.4006H80.5171V20.1572H84.9652V21.4006H83.249L85.8058 27.3606L88.3218 21.4006H86.6055V20.1572H90.8027V21.4006Z",
    fill: "#2755A6",
    id: "path6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.099 27.9855C97.072 27.9855 97.9301 26.567 97.9301 24.8683H96.5817C95.4317 24.8683 93.1259 24.8683 93.1259 26.4853C93.1259 27.6528 94.1416 27.9855 95.099 27.9855ZM97.9301 27.2091H97.8893C97.4982 28.6101 96.3307 29.2347 94.9063 29.2347C93.1317 29.2347 91.4155 28.4759 91.4155 26.4911C91.4155 23.7825 94.0716 23.6308 96.2139 23.6308H97.9301V23.1054C97.9301 21.6811 97.1888 21.2141 95.7819 21.2141C94.5736 21.2141 93.5754 21.4651 93.4586 22.7318H91.7424C91.8592 20.6887 93.6571 19.9648 95.566 19.9648C97.6733 19.9648 99.5238 20.4143 99.5238 22.7084V27.7929H101.082V29.0421H97.9243V27.2091H97.9301Z",
    fill: "#2755A6",
    id: "path8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.209 27.7869H103.75V17.548H102.209V16.2988H105.35V27.7869H106.891V29.0362H102.209V27.7869Z",
    fill: "#2755A6",
    id: "path10",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.139 20.8577H123.656C123.44 18.5402 122.057 17.3494 119.815 17.3494C116.89 17.3494 115.174 19.0831 115.174 22.6673C115.174 25.7261 116.733 27.9852 119.815 27.9852C121.706 27.9852 123.364 26.8002 123.364 24.7162H125.197C125.197 27.9502 122.64 29.2344 119.815 29.2344C115.56 29.2344 113.335 26.7593 113.335 22.6731C113.335 18.5869 115.56 16.1118 119.815 16.1118C120.965 16.1118 122.897 16.6372 123.621 17.8864H123.662V16.3103H125.145V20.8693L125.139 20.8577Z",
    fill: "#2755A6",
    id: "path12",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.217 27.9855C132.19 27.9855 133.049 26.567 133.049 24.8683H131.7C130.55 24.8683 128.244 24.8683 128.244 26.4853C128.244 27.6528 129.26 27.9855 130.217 27.9855ZM133.049 27.2091H133.008C132.617 28.6101 131.449 29.2347 130.025 29.2347C128.25 29.2347 126.534 28.4759 126.534 26.4911C126.534 23.7825 129.19 23.6308 131.332 23.6308H133.049V23.1054C133.049 21.6811 132.307 21.2141 130.9 21.2141C129.692 21.2141 128.694 21.4651 128.577 22.7318H126.861C126.978 20.6887 128.776 19.9648 130.684 19.9648C132.792 19.9648 134.642 20.4143 134.642 22.7084V27.7929H136.201V29.0421H133.043V27.2091H133.049Z",
    fill: "#2755A6",
    id: "path14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.012 27.787H138.553V21.4008H137.012V20.1575H140.153V21.9671H140.193C140.468 20.6245 141.577 19.959 142.925 19.959C143.217 19.959 143.433 19.9765 143.649 19.9998V21.3016C143.398 21.2607 143.065 21.2024 142.692 21.2024C140.45 21.2024 140.158 23.5607 140.158 25.3703V27.787H141.991V29.0362H137.018V27.787H137.012Z",
    fill: "#2755A6",
    id: "path16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.846 18.1318H146.013V16.2988H147.846V18.1318ZM144.706 27.7928H146.247V21.4066H144.706V20.1632H147.846V27.7986H149.387V29.0478H144.706V27.7986V27.7928Z",
    fill: "#2755A6",
    id: "path18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.853 27.9854C158.552 27.9854 159.527 26.6019 159.527 24.5997C159.527 22.8076 158.593 21.214 156.853 21.214C154.688 21.214 153.73 22.8076 153.73 24.5997C153.73 26.6078 154.723 27.9854 156.853 27.9854ZM150.572 27.7928H152.131V17.548H150.572V16.2988H153.73V21.7685H153.771C154.279 20.6185 155.645 19.9589 156.853 19.9589C159.603 19.9589 161.243 21.751 161.243 24.5939C161.243 27.4367 159.685 29.2288 156.853 29.2288C155.604 29.2288 154.197 28.5283 153.771 27.2207H153.73V29.0303H150.572V27.7811V27.7928Z",
    fill: "#2755A6",
    id: "path20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.202 27.9854C169.9 27.9854 170.875 26.6019 170.875 24.5997C170.875 22.8076 169.941 21.214 168.202 21.214C166.036 21.214 165.079 22.8076 165.079 24.5997C165.079 26.6078 166.071 27.9854 168.202 27.9854ZM161.921 27.7928H163.479V17.548H161.921V16.2988H165.079V21.7685H165.12C165.627 20.6185 166.993 19.9589 168.202 19.9589C170.951 19.9589 172.592 21.751 172.592 24.5939C172.592 27.4367 171.033 29.2288 168.202 29.2288C166.953 29.2288 165.546 28.5283 165.12 27.2207H165.079V29.0303H161.921V27.7811V27.7928Z",
    fill: "#2755A6",
    id: "path22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.342 23.7942C181.242 22.1772 180.268 21.2024 178.534 21.2024C176.993 21.2024 175.627 22.1539 175.627 23.7942H181.342ZM175.627 25.0376C175.627 27.0807 176.777 27.9796 178.867 27.9796C179.882 27.9796 181.283 27.4134 181.383 26.2693H182.865C182.807 28.4525 180.524 29.2289 178.651 29.2289C175.761 29.2289 173.911 27.4951 173.911 24.5939C173.911 21.6927 175.761 19.959 178.651 19.959C181.809 19.959 182.924 22.2006 182.941 25.0434H175.627V25.0376Z",
    fill: "#2755A6",
    id: "path24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.066 27.9855C190.04 27.9855 190.898 26.567 190.898 24.8683H189.549C188.399 24.8683 186.093 24.8683 186.093 26.4853C186.093 27.6528 187.109 27.9855 188.066 27.9855ZM190.898 27.2091H190.857C190.466 28.6101 189.298 29.2347 187.874 29.2347C186.099 29.2347 184.383 28.4759 184.383 26.4911C184.383 23.7825 187.039 23.6308 189.181 23.6308H190.898V23.1054C190.898 21.6811 190.156 21.2141 188.749 21.2141C187.541 21.2141 186.543 21.4651 186.426 22.7318H184.71C184.827 20.6887 186.625 19.9648 188.533 19.9648C190.641 19.9648 192.491 20.4143 192.491 22.7084V27.7929H194.05V29.0421H190.892V27.2091H190.898Z",
    fill: "#2755A6",
    id: "path26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.861 27.787H196.402V21.4009H194.861V20.1575H198.002V21.7745H198.042C198.469 20.6478 199.7 19.9648 201.025 19.9648C203.25 19.9648 204.183 21.074 204.183 23.1988V27.7929H205.725V29.0421H201.043V27.7929H202.584V23.5257C202.584 22.1072 202.094 21.2082 200.535 21.2082C198.819 21.2082 198.002 22.4166 198.002 23.9927V27.7929H199.543V29.0421H194.861V27.7929V27.787Z",
    fill: "#2755A6",
    id: "path28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.634 20.8343H222.169C222.011 18.6161 220.727 17.3494 218.48 17.3494C215.555 17.3494 213.839 19.0831 213.839 22.6673C213.839 25.7261 215.397 27.9852 218.48 27.9852C220.82 27.9852 222.245 26.2748 222.227 24.0099H220.062V22.7607H225.543V24.0099H223.809V29.0359H222.21V27.2263H222.169C221.427 28.3938 219.869 29.2344 218.48 29.2344C214.224 29.2344 212 26.7593 212 22.6731C212 18.5869 214.224 16.1118 218.48 16.1118C219.77 16.1118 221.463 16.7131 222.11 17.9039H222.151V16.3103H223.634V20.846V20.8343Z",
    fill: "#2755A6",
    id: "path30",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.494 27.787H228.035V21.4008H226.494V20.1575H229.635V21.9671H229.676C229.95 20.6245 231.059 19.959 232.407 19.959C232.699 19.959 232.915 19.9765 233.131 19.9998V21.3016C232.88 21.2607 232.548 21.2024 232.174 21.2024C229.932 21.2024 229.641 23.5607 229.641 25.3703V27.787H231.473V29.0362H226.5V27.787H226.494Z",
    fill: "#2755A6",
    id: "path32",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.56 27.9855C240.568 27.9855 241.508 26.4269 241.508 24.5939C241.508 22.761 240.574 21.2082 238.56 21.2082C236.546 21.2082 235.537 22.7668 235.537 24.5939C235.537 26.421 236.552 27.9855 238.56 27.9855ZM238.56 19.959C241.45 19.959 243.224 21.6927 243.224 24.5939C243.224 27.4951 241.45 29.2289 238.56 29.2289C235.671 29.2289 233.82 27.4951 233.82 24.5939C233.82 21.6927 235.677 19.959 238.56 19.959Z",
    fill: "#2755A6",
    id: "path34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.207 27.7868H254.748V29.036H251.607V27.4949H251.566C251.216 28.5865 249.944 29.2286 248.659 29.2286C246.359 29.2286 245.419 28.0787 245.419 25.9947V21.4006H243.878V20.1572H247.019V25.6678C247.019 27.0921 247.468 27.9853 249.068 27.9853C250.802 27.9853 251.601 26.8178 251.601 25.2008V21.4006H250.06V20.1572H253.201V27.7926L253.207 27.7868Z",
    fill: "#2755A6",
    id: "path36",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.414 27.9855C263.113 27.9855 264.088 26.602 264.088 24.5998C264.088 22.8077 263.154 21.214 261.414 21.214C259.248 21.214 258.291 22.8077 258.291 24.5998C258.291 26.6078 259.283 27.9855 261.414 27.9855ZM255.133 31.0034H256.692V21.4008H255.133V20.1575H258.291V21.9262H258.332C258.781 20.7762 259.949 19.959 261.414 19.959C264.164 19.959 265.804 21.7511 265.804 24.5939C265.804 27.4368 264.245 29.2289 261.414 29.2289C260.031 29.2289 258.916 28.5867 258.332 27.32H258.291V30.9976H259.85V32.2468H255.127V30.9976L255.133 31.0034Z",
    fill: "#2755A6",
    id: "path38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0222 0.0532227C10.8354 0.0532227 0.106201 10.765 0.106201 23.9284C0.106201 37.0919 10.8354 47.8036 24.0222 47.8036C37.2091 47.8036 47.9383 37.0919 47.9383 23.9284C47.9383 10.765 37.2091 0.0532227 24.0222 0.0532227ZM24.0222 0.905491C36.7596 0.905491 47.086 11.2144 47.086 23.9284C47.086 36.6424 36.7596 46.9513 24.0222 46.9513C11.2849 46.9513 0.958469 36.6424 0.958469 23.9284C0.958469 11.2144 11.2849 0.905491 24.0222 0.905491Z",
    fill: "#2755A6",
    id: "path40",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7371 14.7051L31.7802 16.579L28.9199 19.2L26.007 16.5264L28.2719 14.4541L24.0223 10.5605L19.7726 14.4541L22.0375 16.5264L19.1246 19.2L16.2701 16.579L18.3074 14.7051L11.6819 11.5588L12.5166 20.2449H35.5337L36.3685 11.5588L29.7371 14.7051Z",
    fill: "#2755A6",
    id: "path42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.645 21.6226L12.9077 24.3545H21.5179V34.1381L16.9122 31.949L18.7743 30.2445L13.2229 27.6118L13.8183 33.7878L24.0222 38.6329L34.2319 33.7878L34.8273 27.6118L29.2759 30.2445L31.1322 31.949L26.5265 34.1381V24.3545H35.1367L35.3994 21.6226H12.645Z",
    fill: "#2755A6",
    id: "path44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6244 43.1921V44.056H44.3249C44.6401 44.056 44.8035 43.8634 44.8035 43.6124C44.8035 43.3613 44.6401 43.1921 44.3249 43.1921H43.6244ZM43.4609 43.0578H44.3307C44.7393 43.0578 44.9612 43.2855 44.9612 43.6124C44.9612 43.9101 44.7685 44.1377 44.4475 44.1844L44.9787 44.99H44.8035L44.2782 44.1903H43.6185V44.99H43.4551V43.0578H43.4609ZM44.1731 45.8948C45.2297 45.8948 45.9594 45.0542 45.9594 44.0268C45.9594 42.9994 45.2238 42.2055 44.1731 42.2055C43.1224 42.2055 42.381 42.9936 42.381 44.0268C42.381 45.06 43.1048 45.8948 44.1731 45.8948ZM44.1731 42.0654C45.2939 42.0654 46.1228 42.9119 46.1228 44.0268C46.1228 45.1418 45.3172 46.0291 44.1731 46.0291C43.029 46.0291 42.2234 45.1301 42.2234 44.0268C42.2234 42.9235 43.029 42.0654 44.1731 42.0654Z",
    fill: "#2755A6",
    id: "path46",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs53"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2692_31480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265.703,
    height: 47.7504,
    fill: "white",
    transform: "translate(0.106201 0.0532227)",
    id: "rect50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRccl);
export default __webpack_public_path__ + "static/media/RCCL.77e44cf2c7d488fa81aaa8413af3bb41.svg";
export { ForwardRef as ReactComponent };